import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderEN from "../../headerEN/headeren";
import FooterEN from "../../footerEN/footer";
import './relocationinsurance.scss';

const RelocationInsurance = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div class="main-fluid">
     <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div class="dsk-tab-btn-viewmode-en">
        <div class="relocationinsu-tab-imagebannermain-en">
          <div class="relocationinsu-banner-con-en">
            <div class="relocationinsutab-banne-sec-en">
              <h1 class="relocationinsu-banner-heading-en">Personal Insurance</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="relocationinsu-tab-btn-en">
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "motor-insurance"}>Motor Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "travel-insurance"}>Travel Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "personal-accident"}>Personal Accident Insurance</div>
                <div class="artinsu-tab-btn-item-active-en" onClick={() => window.location.href = "relocation-insurance"}>Relocation Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "health-insurance"}>Health Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "art-insurance"}>Art insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "golf-insurance"}>Golf Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "housemaid-insurance"}>Housemaid Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "yacht-insurance"}>Yacht Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "home-insurance"}>Home Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "life-insurance"}>Life Insurance</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="relocationinsu-banner-con-en">
          <div class="relocationinsu-bdy-en">
            <div class="relocationinsu-dflex-en">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div class="relocationinsu-dlex-lft-en">
                <h2 class="pagetitle-en">Relocation Insurance</h2>
                <p class="pg-txt-con">Is it time to move on? Are you Relocating to a new place? Is it in a new city or are you planning to shift to another country or just moving into a new home that is down the street? You must be concerned about your precious possessions. How do you ensure that nothing untoward happens to them?</p>

                <p class="pg-txt-con">KR Insurance Services offers insurance plans which are designed specifically for this purpose i.e. “The Relocation Insurance”. The Relocation Insurance coverage plan safeguards your assets and protects them from the moment you start your packing till the time you have arrived in your new home and unpacked it all.</p>

                <h3 class="relocationinsu-page-sbu-title-en">Main Cover / Relocation Insurance</h3>

                <p class="pg-txt-con">The Relocation coverage plan is a unique plan which provides benefits unlike any other scheme in the market. There are different options to choose from depending upon the packaging desired.</p>

              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div class="relocationinsu-dlex-rgt-en">
                <img src={process.env.PUBLIC_URL + "/personalinsurance_images/tab_images/relocation_insurance.png"} alt="relocation insurance" />
              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>

            {/* <p class="relocationinsu-txt-con">The Relocation coverage plan is a unique plan which provides benefits unlike any other scheme in the market. There are different options to choose from depending upon the packaging desired.</p> */}

            {/* QUESTION SECTION STARTS HERE */}
            <div class="relocationinsu-keyfeatures-en">
              <p class="relocationinsu-keyfeatures-q-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Full conditions - professionally packed effects.</p>

              <p class="relocationinsu-keyfeatures-q-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Restricted conditions - owner packed effects.</p>

              <p class="relocationinsu-keyfeatures-q-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Cover for motor vehicles.</p>

              <p class="relocationinsu-keyfeatures-q-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Special extensions - for personal effects.</p>

              <p class="relocationinsu-keyfeatures-q-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Storage extensions.</p>
            </div>
            {/* QUESTION SECTION ENDS HERE */}

            <h3 class="relocationinsu-whykrinsu-title-en">Why KR Insurance Services ?</h3>
            <div class="relocationinsu-pins-list-en">
              <div class="relocationinsu-lt-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
              <div class="relocationinsu-lt-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
              <div class="relocationinsu-lt-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
              <div class="relocationinsu-lt-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
            </div>
            {/* ask for quotes button starts here */}
            <div className="askquto-btn-sec">
                    <a href="/contactus" className="askquto-btn">Ask for Quotes</a>
                  </div>
            {/* ask for quotes button starts here */}
          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* TAB-VIEW AND TABS SECTION STARTS HERE */}
      <div class="tab-btn-viewmode-en">
        <div class="relocationinsu-tab-imagebannermain-en">
          <div class="relocationinsu-banner-con-en">
            <div class="relocationinsutab-banne-sec-en">
              <h1 class="relocationinsu-banner-heading-en">Personal Insurance</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="relocationinsu-tab-btn-en">
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "motor-insurance"}>Motor Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "travel-insurance"}>Travel Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "personal-accident"}>Personal Accident Insurance</div>
                <div class="artinsu-tab-btn-item-active-en" onClick={() => window.location.href = "relocation-insurance"}>Relocation Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "health-insurance"}>Health Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "art-insurance"}>Art insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "golf-insurance"}>Golf Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "housemaid-insurance"}>Housemaid Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "yacht-insurance"}>Yacht Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "home-insurance"}>Home Insurance</div>
                <div class="artinsu-tab-btn-item-en" onClick={() => window.location.href = "life-insurance"}>Life Insurance</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="relocationinsu-banner-con-en">
          <div className="tab-imgtxt-en">
            <h2>Relocation Insurance</h2>
            <div className="tabs-cont-en">
              <img className="rgt-img-en" src={process.env.PUBLIC_URL + "/personalinsurance_images/tab_images/relocation_insurance.png"} alt="relocation insurance" />
              <p>Is it time to move on? Are you Relocating to a new place? Is it in a new city or are you planning to shift to another country or just moving into a new home that is down the street? You must be concerned about your precious possessions. How do you ensure that nothing untoward happens to them?</p>
              
              <p>KR Insurance Services offers insurance plans which are designed specifically for this purpose i.e. “The Relocation Insurance”. The Relocation Insurance coverage plan safeguards your assets and protects them from the moment you start your packing till the time you have arrived in your new home and unpacked it all.</p>

              <h3 class="motorinsu-page-sbu-title-en">Main Cover / Relocation Insurance</h3>
              
              <p>The Relocation coverage plan is a unique plan which provides benefits unlike any other scheme in the market. There are different options to choose from depending upon the packaging desired.</p>

              <div class="tabkyfet-en">
                <div class="tabkeyfet-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>
                <div class="tabkeyfet-txt-en">Full conditions - professionally packed effects.</div>
                <div class="tabkeyfet-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>
                <div class="tabkeyfet-txt-en">Restricted conditions - owner packed effects.</div>
                <div class="tabkeyfet-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>
                <div class="tabkeyfet-txt-en">Cover for motor vehicles.</div>
                <div class="tabkeyfet-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>
                <div class="tabkeyfet-txt-en">Special extensions - for personal effects.</div>
                <div class="tabkeyfet-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>
                <div class="tabkeyfet-txt-en">Storage extensions.</div>
              </div>
              <h3 class="motorinsu-page-sbu-title-en">Why KR Insurance Services ?</h3>

            <div class="tab-whykrinsu-pins-list-en">
              <div class="tab-whykrinsu-pinlft-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Competitive Terms</div>
              <div class="tab-whykrinsu-pinlft-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Prompt Claim Services</div>
              <div class="tab-whykrinsu-pinlft-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Wide Quote Comparisons</div>
              <div class="tab-whykrinsu-pinlft-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Best Insurance Industry Practices</div>
            </div>

            {/* ask for quotes button starts here */}
            <div className="askquto-btn-sec">
              <a href="/contactus" className="askquto-btn">Ask for Quotes</a>
            </div>
            {/* ask for quotes button starts here */}

            </div>
          </div>
          
        </div>
      </div>
      {/* TAB-VIEW AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="relocationinsu-tab-imagebannermain-en hidden-desktop hidden-md-device hidden-lg">
        <div class="dropdown-sec">
          <select class="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"motor-insurance"}>Motor Insurance</option>
            <option value={"travel-insurance"}>Travel Insurance</option>
            <option value={"personal-accident"}>Personal Accident Insurance</option>
            <option value={"relocation-insurance"} selected class="active">Relocation Insurance</option>
            <option value={"health-insurance"}>Health Insurance</option>
            <option value={"art-insurance"}>Art insurance</option>
            <option value={"golf-insurance"}>Golf Insurance</option>
            <option value={"housemaid-insurance"}>Housemaid Insurance</option>
            <option value={"home-insurance"}>Home Insurance</option>
            <option value={"yacht-insurance"}>Yacht Insurance</option>
            <option value={"life-insurance"}>Life Insurance</option>
          </select>
        </div>
        <div class="relocationinsu-mob-main-en">
          <h1 class="relocationinsu-banner-heading-en">Relocation Insurance</h1>
          <div class="relocationinsu-mob-img-en">
            <img src={process.env.PUBLIC_URL + "/personalinsurance_images/tab_images/relocation_insurance.png"} alt="relocation insurance" />
          </div>
          <p class="relocationinsu-mob-txt-en">Is it time to move on? Are you Relocating to a new place? Is it in a new city or are you planning to shift to another country or just moving into a new home that is down the street? You must be concerned about your precious possessions. How do you ensure that nothing untoward happens to them?</p>

          <p class="relocationinsu-mob-txt-en">KR Insurance Services offers insurance plans which are designed specifically for this purpose i.e. “The Relocation Insurance”. The Relocation Insurance coverage plan safeguards your assets and protects them from the moment you start your packing till the time you have arrived in your new home and unpacked it all.</p>

          <h3 class="relocationinsu-subtitle-en">Main Cover / Relocation Insurance</h3>

          <p class="relocationinsu-mob-txt-en">The Relocation coverage plan is a unique plan which provides benefits unlike any other scheme in the market. There are different options to choose from depending upon the packaging desired.</p>

          {/* QUESTION SECTION STARTS HERE */}
          <div class="relocationinsu-mob-keyfeatures-en">
            <div class="relocationinsu-mob-keyfeatures-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="relocationinsu-mob-keyfeatures-q-en">Full conditions - professionally packed effects.</div>

            <div class="relocationinsu-mob-keyfeatures-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="relocationinsu-mob-keyfeatures-q-en">Restricted conditions - owner packed effects.</div>

            <div class="relocationinsu-mob-keyfeatures-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="relocationinsu-mob-keyfeatures-q-en">Cover for motor vehicles.</div>

            <div class="relocationinsu-mob-keyfeatures-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="relocationinsu-mob-keyfeatures-q-en">Special extensions - for personal effects.</div>

            <div class="relocationinsu-mob-keyfeatures-img-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="relocationinsu-mob-keyfeatures-q-en">Storage extensions.</div>
          </div>
          {/* QUESTION SECTION ENDS HERE */}

          <h3 class="relocationinsu-whykrinsu-mob-title-en">Why KR Insurance Services ?</h3>

          <div class="relocationinsu-mob-whykrlist-en">
            <div class="relocationinsu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
            <div class="relocationinsu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
            <div class="relocationinsu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
            <div class="relocationinsu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
          </div>
          {/* ask for quotes button starts here */}
          <div className="askquto-btn-sec">
                    <a href="/contactus" className="askquto-btn">Ask for Quotes</a>
                  </div>
            {/* ask for quotes button starts here */}
        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default RelocationInsurance;